import script from "./TransactionsRow.vue?vue&type=script&setup=true&lang=js"
export * from "./TransactionsRow.vue?vue&type=script&setup=true&lang=js"

import "./TransactionsRow.vue?vue&type=style&index=0&id=228995e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-228995e0"]])

export default __exports__